(function () {
  angular.module('MktzapApp.Controllers')
    .controller('CardSettingsController', cardSettings);

  cardSettings.$inject = ['$rootScope', 'LocalStorageService', 'StatusService', 'NotificationService', 'CompanyService', 'FoundationApi'];

  function cardSettings ($rootScope, LocalStorageService, StatusService, NotificationService, CompanyService, FoundationApi) {
    if (LocalStorageService.checkInPause()) {
      LocalStorageService.sendToBlockPage();
    }

    var vmCardSettingsCtrl = this;

    $rootScope.getPageLabels('menu.config.cardSett');

    vmCardSettingsCtrl.selectedSectors = [];

    vmCardSettingsCtrl.getClassificationStatus = function () {
      StatusService
        .classification_statuses()
        .$promise
        .then(function (data) {
          vmCardSettingsCtrl.classificationStatus = data;
          angular.forEach(data, function (status, key) {
            if (status.is_default) {
              vmCardSettingsCtrl.status_id = status.id;
            }
          });
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorStatus);
        });
    };

    vmCardSettingsCtrl.setDefaultStatusOfClassification = function () {
      StatusService
        .setDefault({ status_id: vmCardSettingsCtrl.status_id })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.saveStatus);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorSaveStatus);
        });
    };

    vmCardSettingsCtrl.loadMetadata = function () {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          angular.forEach(data.dataDefinition, function (value, key) {
            data.dataDefinition[key].is_active = Boolean(data.dataDefinition[key].is_active)

            if (data.dataDefinition[key].params == '') {
              data.dataDefinition[key].params = {}
            }

            data.dataDefinition[key].params = angular.fromJson(data.dataDefinition[key].params)
          });

          vmCardSettingsCtrl.metadata = data;
          vmCardSettingsCtrl.getClassificationStatus();
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadMetadata);
        });
    };

    vmCardSettingsCtrl.saveMetadata = function () {
      CompanyService
        .saveMetadata(vmCardSettingsCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.configSaved);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
        });
    }

    vmCardSettingsCtrl.showField = function (key, label, active) {
      vmCardSettingsCtrl.saveMetadata();
      CompanyService
        .showField({
          key: key,
          label: label,
          active: active
        })
        .$promise
        .then(function (data) {
          if (!active) { vmCardSettingsCtrl.metadata.dataDefinition[key].params.required = active; }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
        });
    }

    vmCardSettingsCtrl.saveMetadataDefinition = function (key) {
      CompanyService
        .updateMetadataDefinition(vmCardSettingsCtrl.metadata.dataDefinition[key])
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.configSaved);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
        });
    }

    vmCardSettingsCtrl.showSectors = function (key, label) {
      vmCardSettingsCtrl.selectedKey = key;
      vmCardSettingsCtrl.selectedLabel = label;

      CompanyService
        .allSectorsByKey({
          key: key
        })
        .$promise
        .then(function (data) {
          vmCardSettingsCtrl.sectors = data;
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveConfig);
        });

      FoundationApi.publish('sectorsModal', 'open');
    }

    vmCardSettingsCtrl.saveSectors = function () {
      var sectors = document.getElementsByName('sectors');
      var sectorsDisabled = document.getElementsByName('sectors_disabled');
      var sectorsArr = [];
      var sectorsDisabledArr = [];

      for (var i = 0; i < sectorsDisabled.length; i++) {
        sectorsDisabledArr[sectorsDisabled[i].id] = sectorsDisabled[i].checked;
      }

      for (var i = 0; i < sectors.length; i++) {
        var sector = { id: sectors[i].id, active: sectors[i].checked, disabled: sectorsDisabledArr[sectors[i].id] };
        sectorsArr.push(sector);
      }

      CompanyService
        .saveSectors({
          key: vmCardSettingsCtrl.selectedKey,
          label: vmCardSettingsCtrl.selectedLabel,
          sectors: sectorsArr
        })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.configSaved);
          FoundationApi.publish('sectorsModal', 'close');
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorSaveSectors);
        });
    }

    vmCardSettingsCtrl.changeShowSector = function (sectorId) {
      var sectors = document.getElementsByName('sectors');
      var sectorsDisabled = document.getElementsByName('sectors_disabled');
      var checked;
      var sectorDisabled;

      for (var i = 0; i < sectors.length; i++) {
        if (sectors[i].id == sectorId) {
          checked = sectors[i].checked;
        }
      }

      for (var i = 0; i < sectorsDisabled.length; i++) {
        if (sectorsDisabled[i].id == sectorId) {
          sectorDisabled = sectorsDisabled[i];
        }
      }

      for (var i = 0; i < vmCardSettingsCtrl.sectors.length; i++) {
        if (vmCardSettingsCtrl.sectors[i].id == sectorId) {
          vmCardSettingsCtrl.sectors[i].is_active = !!checked;
        }
      }

      if (!checked) {
        sectorDisabled.checked = false;
      }
    }

    vmCardSettingsCtrl.loadMetadata();
  }
})();
